export default {
  getDetailsOfASubject: "/subject/getSubject",
  getSubjects: "/subject/getSubjects",
  getSubjectDetails: '/subject/getSubjectDetails',
  getSubjectsOfACourseYear: '/subject/getSubjectsOfACourseYear',
  updateMultipleSubjectDetails: "/subject/updateMultipleSubjectDetails"
};
